import React from 'react';
import { TableBody, TableContainer, Table, TableHead, TableRow, TableCell, Paper } from '@mui/material';

const DataTable = ({ dataArray, headline, columns }) => {
    // Default columns if none provided
    const tableColumns = columns || [
        { id: 'label', label: 'Symbol' },
        { id: 'value', label: 'Quantity' },
        { id: 'percentage', label: 'Percentage' }
    ];

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 300 }} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        {tableColumns.map((column) => (
                            <TableCell 
                                key={column.id} 
                                align={column.id === 'label' ? 'left' : 'right'}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {dataArray.map((item, index) => (
                        <TableRow key={index}>
                            {tableColumns.map((column) => (
                                <TableCell 
                                    key={column.id} 
                                    component={column.id === 'label' ? 'th' : 'td'} 
                                    scope={column.id === 'label' ? 'row' : undefined}
                                    align={column.id === 'label' ? 'left' : 'right'}
                                >
                                    {column.id === 'percentage' && item[column.id] && !item[column.id].toString().endsWith('%') 
                                        ? `${item[column.id]}%` 
                                        : item[column.id]}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default DataTable;